import { RouteProps } from '../../routes/AppRouter'
import { Table as FGU } from '../../features/form-generator/Table'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function FormGeneratorUsers(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <FGU></FGU>
    </>
  )
}
